import { render, staticRenderFns } from "./shuzi.vue?vue&type=template&id=18a62bee"
import script from "./shuzi.vue?vue&type=script&lang=ts"
export * from "./shuzi.vue?vue&type=script&lang=ts"
import style0 from "./shuzi.vue?vue&type=style&index=0&id=18a62bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports